import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import MuiCard from '@mui/material/Card';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import AutorenewRoundedIcon from '@mui/icons-material/AutorenewRounded';

import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

import { Country, State, Population, Address } from '../interfaces/Geonames';
import { HostData } from '../interfaces/HostData';
import { geoFetch } from '../assets/aux_func/geoFetch';
import { CLIENT_TYPE, FIRST_CHANNEL, POSSIBLE_CLIENT, PROF_TYPE, SOCIAL_NETWORKING } from '../constants/mapping';
import { Position } from '../interfaces/Position';
import { Link } from '@mui/material';
import { POLICY_URLs } from '../constants/policies';
import MessagePopup from './ux/MessagePopup';

type Option = {
    [key: string]: string
}

const Form = () => {
    const API_URL = process.env.REACT_APP_API_URL;
    const GEONAME_BASE_URL = process.env.REACT_APP_GEONAME_BASE_URL;

    const clientTypeList: Option = CLIENT_TYPE;
    const profTypeList: Option = PROF_TYPE;
    // const languageList: Option = LANG;
    const channelList: Option = FIRST_CHANNEL;
    const heardList: Option = SOCIAL_NETWORKING;
    const clientStateList: Option = POSSIBLE_CLIENT;

    const formRef = useRef<HTMLFormElement | null>(null);

    const [captchaValue, setCaptchaValue] = useState<string | null>(null);
    const [captchaIsValid, setCaptchaIsValid] = useState(true);

    const [admin, setAdmin] = useState(false);
    const [loading, setLoading] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
    const [popUpContent, setPopUpContent] = useState<string>("");
    const { t, i18n } = useTranslation('common');
    const [lang, setLang] = useState(i18n.language);
    const [userLang, setUserLang] = useState("es-ES");
    const [position, setPosition] = useState<Position>();
    const [policyURL, setPolicyURL] = useState<string | null>(null);

    const [countryId, setCountryId] = useState<number>(0);
    const [stateId, setStateId] = useState<number>(0);
    const [populationId, setPopulationId] = useState<number>(0);
    const [direction, setDirection] = useState("");
    const [postalcode, setPostalcode] = useState("");
    const [checked, setChecked] = useState(false);

    const [countries, setCountries] = useState<Country[] | null>(null);
    const [states, setStates] = useState<State[]>([]);
    const [populations, setPopulations] = useState<Population[]>([]);
    const [address, setAddress] = useState<Address>();

    const [hostData, setHostData] = useState<HostData>();

    const [phone, setPhone] = useState("");

    const [emailError, setEmailError] = useState('');
    const [firstnameError, setFirstnameError] = useState('');
    const [lastnameError, setLastnameError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [policyError, setPolicyError] = useState('');
    const [captchaError, setCaptchaError] = useState('');

    const getPageName = (url: string) => {
        try {
            let hostname = new URL(url).hostname;
            let parts = hostname.split('.');
            return parts.length > 2 ? parts[1] : parts[0];
        } catch (error) {
            return null;
        }
    }

    useEffect(() => {
        const script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/enterprise.js?render=6LdaDNYqAAAAADy9v1OsfCIyDVGcqLlo_Fky7CGY";
        script.async = true;
        script.defer = true;
        document.body.appendChild(script);
    
        script.onload = () => {
            const grecaptcha = (window as any).grecaptcha;
            if (grecaptcha) {
                // grecaptcha.enterprise.ready(async () => {
                //     const token = await grecaptcha.enterprise.execute('6LdaDNYqAAAAADy9v1OsfCIyDVGcqLlo_Fky7CGY', {action: 'LOGIN'});
                //     setCaptchaValue(token)
                // });
                // grecaptcha.render("recaptcha-container", {
                //     sitekey: "6LdaDNYqAAAAADy9v1OsfCIyDVGcqLlo_Fky7CGY",
                //     callback: (token: string) => setCaptchaValue(token),
                // });
            }
        };
    }, []);

    useEffect(() => {
        const getMessage = (event: MessageEvent<HostData> ) => {
            const data = {
                lang: 'es',
                userLang: 'es-ES',
                position: {
                    latitude: "",
                    longitude: ""
                },
                webOrigin: event.origin,
                webOriginUrl: event.origin
            }
            if(event?.data) {
                data.lang = event.data.lang;
                data.userLang = event.data.userLang;
                data.position = event.data.position;
                data.webOrigin = event.data.webOrigin;
                data.webOriginUrl = event.data.webOriginUrl;
            }

            const { lang, userLang, position, webOrigin, webOriginUrl } = data;
            if(webOriginUrl || event.origin) {
                const hostname = getPageName(webOriginUrl);
                if(hostname) {
                    let url = POLICY_URLs[hostname]?.get(lang.toLowerCase());
                    if(!url && hostname.includes("aplicadormicrocemento")) {
                        url = POLICY_URLs["aplicadormicrocemento"]?.get(lang.toLowerCase());
                    }
                    if(!url && hostname.includes("pintura")) {
                        url = POLICY_URLs["pintura"]?.get(lang.toLowerCase());
                    }
                    if(!url && hostname.includes("hormigonimpres")) {
                        url = POLICY_URLs["hormigonimpres"]?.get(lang.toLowerCase());
                    }
                    if(!url && hostname.includes("beton")) {
                        url = POLICY_URLs["beton"]?.get(lang.toLowerCase());
                    }

                    if(url) {
                        let base = `https://${new URL(webOriginUrl).hostname}`
                        webOriginUrl.includes(`/${lang}`) ? base += `/${lang}/` : base += "/";
                        const policyURL = `${base}${url}`
                        setPolicyURL(policyURL);
                    }
                };
            }
            const language = lang?.includes('-') ? 
                lang.includes('zh') ?
                lang.replace('-', '_') :
                lang.split('-')[0]
            : lang;

            language && i18n.changeLanguage(language).then( () => {
                setPolicyError("");
                setPolicyError(checked ? "" : t("accept_policy_error"));
            });

            language && setLang(language);

            userLang && setUserLang(data.userLang);
            position && setPosition(data.position);

            if(lang && userLang && webOrigin && webOriginUrl) {
                setHostData({ lang, userLang, position, webOrigin, webOriginUrl })
            }

        };

        setAdmin(false);
    
        window.addEventListener('message', getMessage);
        return () => window.removeEventListener('message', getMessage);
    }, [i18n]);

    useEffect(() => {
        const customFetch = async () => {
            const url = `${GEONAME_BASE_URL}/countries?lang=${lang}`;
    
            try {  
                const countries = await geoFetch<Country[]>(url, 'geonames');
    
                if (countries) {
                    setCountries(countries);
                }
    
                if (address) {
                    const country = countries?.find(c => c.countryCode === address.countryCode);
                    country && setCountryId(country.geonameId);
                }
            } catch (error) {
                console.error("Error fetching countries:", error);
            }
        };
        customFetch();
    }, [lang, address]);

    useEffect(() => {
        const customFetch = async () => {    
            const url = `${GEONAME_BASE_URL}/states?lang=${lang}&geoId=${countryId}`;

            try {  
                const states = await geoFetch<State[]>(url, 'geonames');
    
                if (states) {
                    setStates(states);
                }
    
                if (address) {
                    const state = states?.find(c => c.adminCode1 === address.adminCode1);
                    state && setStateId(state.geonameId);
                }
            } catch (error) {
                console.error("Error fetching states:", error);
            }
        };
        customFetch();
    }, [countryId]);

    useEffect(() => {
        const customFetch = async () => {  
            const state = states?.find( state => state.geonameId === stateId);
            const countryCode = state?.countryCode;
            const stateCode = state?.adminCode1;
            const url = `${GEONAME_BASE_URL}/cities?lang=es&country=${countryCode}&state=${stateCode}`;

            try {  
                const populations = await geoFetch<Population[]>(url, 'geonames');
    
                if (populations) {
                    setPopulations(populations);
                }
    
                if (address) {
                    const population = populations?.find(c => c.toponymName === address.locality);
                    population && setPopulationId(population.geonameId);
                }
            } catch (error) {
                console.error("Error fetching populations:", error);
            }
        };
        customFetch();
    }, [stateId]);

    useEffect(() => {
        if(address) {
            setDirection(address.street + ", " + address.houseNumber);
            setPostalcode(address.postalcode);
        }
    }, [populationId, address]);

    useEffect( () => {
        if(!position) return;

        const customFetch = async () => {    
            if(!position?.latitude && !position?.longitude) return;

            const { latitude: lat, longitude: lng } = position;
            const url = `${GEONAME_BASE_URL}/address?lang=${lang}&lat=${lat}&lng=${lng}`;

            try {  
                const address = await geoFetch<Address>(url, 'address');    
                if (address) {
                    setAddress(address);
                }
            } catch (error) {
                console.error("Error fetching address:", error);
            }
        };
        customFetch();
    }, [i18n, position]);
    
    useEffect( () => {
        setPolicyError(checked ? "" : t("accept_policy_error"));
    }, [checked])

    useEffect( () => {
        const validateCaptcha = async () => {
            if(!captchaValue) return;

            const headers = new Headers();

            headers.append('Content-Type', 'application/json');
            const isValid = await fetch(`${API_URL}/verify-recaptcha`, {
                method: "POST",
                headers,
                body: JSON.stringify({captcha: captchaValue})
            })

            const data = await isValid.json();

            setCaptchaIsValid(data['success']);
        }

        // validateCaptcha();
    }, [captchaValue])

    const getPopulationName = (population: Population) => {
        const name = population?.alternateNames?.find( o => o.lang === lang)?.name ?? population.name;
        return name;
    }

    const validateInputs = () => {
        const phoneRegex = /^[0-9]{10,15}$/;

        const email = document.getElementById('email') as HTMLInputElement;
        const firstname = document.getElementById('firstname') as HTMLInputElement;
        const lastname = document.getElementById('lastname') as HTMLInputElement;

        let isValid = true;

        if (!captchaValue) {
            setCaptchaError("Por favor, completa el CAPTCHA");
            return;
          }

        if (!email.value || !/\S+@\S+\.\S+/.test(email.value)) {
            setEmailError(t("email_error"));
            isValid = false;
        } else {
            setEmailError('');
        }

        if ((!phone || phone.length < 10) && !phoneRegex.test(phone)) {
            setPhoneError(t("phone_error"));
            isValid = false;
        } else {
            setPhoneError('');
        }

        if (!firstname.value || firstname.value.length < 1) {
            setFirstnameError(t("first_name_error"));
            isValid = false;
        } else {
            setFirstnameError('');
        }

        if (!lastname.value || lastname.value.length < 1) {
            setLastnameError(t("last_name_error"));
            isValid = false;
        } else {
            setLastnameError('');
        }

        return isValid;
    };

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (firstnameError.length || emailError.length || lastnameError.length || phoneError.length || (policyError.length && policyURL?.length)) {
            return;
        }

        const country = countries?.find( country => country.geonameId === countryId);
        const state = states?.find( state => state.geonameId === stateId);
        const population = populations?.find( population => population.geonameId === populationId);

        const formData = new FormData(event.currentTarget);

        const data = {
            firstname: formData.get('firstname'),
            lastname: formData.get('lastname'),
            phone: phone,
            email: formData.get('email'),
            webOriginUrl: hostData?.webOriginUrl ?? '__gnpo-api.azurewebsites.net__',
            client_type: formData.get('client_type'),
            lang,
            message: formData.get('message'),
            acceptPolicy: !!formData.get("acceptPolicy") || false,
            allowExtraEmails: !!formData.get("allowExtraEmails"),
            webOrigin: hostData?.webOrigin ?? 'New Lead Form',
            country: population?.countryCode?.toUpperCase() ?? country?.countryCode?.toUpperCase(),
            state: population?.adminName1 ?? state?.name,
            population: population?.name,
            direction,
            zip_code: postalcode,
            heard_about: formData.get('heard_about'),
            channel: 'Aún no está contactado',
        }

        const headers = new Headers();
        headers.append("Content-Type", "application/json");

        setLoading(true);

        fetch(`${API_URL}/`, {
            method: "POST",
            headers,
            body: JSON.stringify(data)
        })
        .then( res => res.json())
        .then( data => {
            switch (data.status) {
                case "EXISTS":
                    setPopUpContent("exists");
                    break;
                case "CREATED":
                    setPopUpContent("thanks");
                    break;
                default:
                    setPopUpContent(data.message);
            }
            
            setPopupOpen(true);
        })
        .catch( error => {
            setPopUpContent("server_error");
            setPopupOpen(true);
        })
        .finally(() => {
            setLoading(false);
            if (formRef?.current) {
                formRef.current.reset();
                setPhone("");
                setChecked(false);
            }
        })
    };

    return (
        <>
        <Stack direction="column" justifyContent="space-between">
            <MuiCard variant="outlined">
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    ref={formRef}
                    sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
                >
                    <div className='form__person'>
                    <FormControl>
                        <TextField
                            label={t("first_name")}
                            variant="outlined"
                            autoComplete="firstname"
                            name="firstname"
                            required
                            fullWidth
                            id="firstname"
                            placeholder={t("first_name")}
                            error={!!firstnameError.length}
                            helperText={firstnameError}
                            color={firstnameError.length ? 'error' : 'primary'}
                        />
                    </FormControl>

                    <FormControl>
                        <TextField
                            label={t("last_name")}
                            variant="outlined"
                            autoComplete="lastname"
                            name="lastname"
                            required
                            fullWidth
                            id="lastname"
                            placeholder={t("last_name")}
                            error={!!lastnameError.length}
                            helperText={lastnameError}
                            color={lastnameError.length ? 'error' : 'primary'}
                        />
                    </FormControl>

                    <FormControl>
                        <TextField
                            label={t("email")}
                            variant="outlined"
                            autoComplete="email"
                            name="email"
                            required
                            fullWidth
                            id="email"
                            placeholder={t("email")}
                            error={!!emailError.length}
                            helperText={emailError}
                            color={emailError.length ? 'error' : 'primary'}
                        />
                    </FormControl>

                    <FormControl>
                        <PhoneInput
                            country={userLang.slice(3).toLowerCase()}
                            value={phone}
                            onChange={(value) => {
                                setPhone(value);
                            }}
                            inputProps={{
                                name: t("phone"),
                                required: true,
                            }}
                            containerClass="mui-phone-input"
                            inputClass={`mui-phone-textfield ${phoneError.length ? "error" : ""}`}
                        />
                        {!!phoneError.length && <FormHelperText className='Mui-error'>{phoneError}</FormHelperText>}
                    </FormControl>

                    </div>


                    {countries  && <br />}
                    <div className='form__aux'>
                        {
                            countries &&

                            <FormControl>
                                <InputLabel id="country">{t("country")}</InputLabel>
                                <Select
                                    name="country"
                                    id="country"
                                    labelId="country"
                                    label={t("country")}
                                    value={countryId}
                                    onChange={(value) => setCountryId(value.target.value as number)}
                                >
                                    {
                                        countries.sort((a, b) => a.countryName.localeCompare(b.countryName))?.map((country: Country) => (
                                            <MenuItem key={country.geonameId} value={country.geonameId}>
                                                {country.countryName}
                                            </MenuItem>)
                                        )
                                    }
                                </Select>
                            </FormControl>
                        }

                        {
                            !!states?.length &&
                            <FormControl>
                                <InputLabel id="state">{t("state")}</InputLabel>
                                <Select
                                    name="state"
                                    id="state"
                                    labelId="state"
                                    label={t("state")}
                                    value={stateId}
                                    onChange={(value) => setStateId(value.target.value as number)}
                                >
                                    {
                                        states.sort((a, b) => a.name.localeCompare(b.name)).map((state: State) => (
                                            <MenuItem key={state.geonameId} value={state.geonameId}>
                                                {state.name}
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        }

                        {
                            !!populations?.length &&
                            <FormControl>
                                <InputLabel id="population">{t("population")}</InputLabel>
                                <Select
                                    name="population"
                                    id="population"
                                    labelId="population"
                                    label={t("population")}
                                    value={populationId}
                                    onChange={(value) => setPopulationId(value.target.value as number)}
                                >
                                    {
                                        populations.sort((a, b) => a.name.localeCompare(b.name)).map((population: Population) => (
                                            <MenuItem key={population.geonameId} value={population.geonameId}>
                                                {getPopulationName(population)}
                                            </MenuItem>
                                        ))
                                    }
                                </Select>
                            </FormControl>
                        }

                        {
                            !!populationId &&
                            <>
                            <FormControl>
                                <TextField
                                    label={t("postal_code")}
                                    variant="outlined"
                                    autoComplete="postal_code"
                                    name="postal_code"
                                    fullWidth
                                    id="postal_code"
                                    placeholder={t("postal_code")}
                                    value={postalcode}
                                    onChange={(value) => setPostalcode(value.target.value)}
                                />
                            </FormControl>

                            <FormControl className="direction">
                                <TextField
                                    label={t("direction")}
                                    variant="outlined"
                                    autoComplete="direction"
                                    name="direction"
                                    fullWidth
                                    id="direction"
                                    placeholder={t("direction")}
                                    value={direction}
                                    onChange={(value) => setDirection(value.target.value)}
                                />
                            </FormControl>
                            </>
                        }                          
                    </div>

                    <br />

                    <FormControl>
                        <InputLabel id="client_type">{t("client_type")}</InputLabel>
                        <Select
                            name="client_type"
                            id="client_type"
                            labelId="client_type"
                            label={t("client_type")}
                        >
                            {
                                Object.keys(clientTypeList).map((key: string) => (
                                    <MenuItem key={clientTypeList[key]} value={clientTypeList[key]}>
                                        {t(key)}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>

                    <FormControl>
                        <InputLabel id="heard_about">{t("heard_about")}</InputLabel>
                        <Select
                            name="heard_about"
                            id="heard_about"
                            labelId="heard_about"
                            label={t("heard_about")}
                        >
                            {
                                Object.keys(heardList).map((key: string) => (
                                    <MenuItem key={heardList[key]} value={heardList[key]}>
                                        {key}
                                    </MenuItem>
                                ))
                            }
                        </Select>
                    </FormControl>

                    { admin && 
                    <>
                    <br />
                    <div className="admin">
                        <FormControl>
                            <InputLabel id="prof_type">{t("prof_type")}</InputLabel>
                            <Select
                                name="prof_type"
                                id="prof_type"
                                labelId="prof_type"
                                label={t("prof_type")}
                            >
                                {
                                    Object.keys(profTypeList).map((key: string) => (
                                        <MenuItem key={profTypeList[key]} value={profTypeList[key]}>
                                            {key}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>

                        <FormControl>
                            <InputLabel id="channel">{t("channel")}</InputLabel>
                            <Select
                                name="channel"
                                id="channel"
                                labelId="channel"
                                label={t("channel")}
                            >
                                {
                                    Object.keys(channelList).map((key: string) => (
                                        <MenuItem key={channelList[key]} value={channelList[key]}>
                                            {key}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>

                        <FormControl>
                            <InputLabel id="clientState">{t("client_state")}</InputLabel>
                            <Select
                                name="clientState"
                                id="clientState"
                                labelId="clientState"
                                label={t("client_state")}
                            >
                                {
                                    Object.keys(clientStateList).map((key: string) => (
                                        <MenuItem key={clientStateList[key]} value={clientStateList[key]}>
                                            {key}
                                        </MenuItem>
                                    ))
                                }
                            </Select>
                        </FormControl>
                    </div>
                    <br />
                    </>
                    }

                    <FormControl>
                        <TextField
                            label={t("message")}
                            variant="outlined"
                            autoComplete="message"
                            fullWidth
                            multiline
                            name="message"
                            id="message"
                            placeholder={t("message")}
                            // value={postalcode}
                            // onChange={(value) => setPostalcode(value.target.value)}
                        />
                    </FormControl>

                    { !admin && 

                    <div className="checkboxes">
                        { policyURL &&
                        <FormControl error={!!policyError.length} component="fieldset">
                            <div className="accept_policy">
                                <Checkbox
                                    color="primary"
                                    name="acceptPolicy"
                                    id="acceptPolicy"
                                    checked={checked}
                                    onChange={() => setChecked(!checked)}
                                />
                                <Link className='accept_policy_link' href={policyURL} target="_blank">{t("accept_policy")}</Link>
                                
                                {/* <Link className='accept_policy_link' onClick={handlePopup} >{t("accept_policy")}</Link> */}
                                
                            </div>
                            {!!policyError.length && <FormHelperText>{policyError}</FormHelperText>}
                        </FormControl>
                        }

                        <FormControl className='agree_commercial'>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        color="primary"
                                        name='allowExtraEmails'
                                        id='allowExtraEmails'
                                    />
                                }
                                label={t("agree_commercial")}
                            />
                        </FormControl>
                        {/* <FormControlLabel
                            control={<Checkbox value="allowThird" color="primary" name='allowThird' id='allowThird' />}
                            label={t("accept_third")}
                        /> */}
                    </div>
                    }

                    <br />
                    
                    <div id="recaptcha-container"></div>
                    
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        disabled={loading}
                        onClick={validateInputs}
                    >
                        {t("send")}
                        {loading && <AutorenewRoundedIcon className='loading'/>}
                    </Button>
                </Box>
            </MuiCard>
        </Stack>

        <MessagePopup open={popupOpen} content={popUpContent} onClose={() => setPopupOpen(false)}></MessagePopup>
        </>
    );
};

export default Form;